module.exports = __webpack_public_path__ + "anchor.jpg?1fc85ab360c66da63063c8e1b5a87f49";